import { extendTheme } from "@chakra-ui/react";

const inputStyles = {
  bg: "white",
  fontSize: "sm",
  border: "1px solid",
  borderColor: "gray.200",
  _hover: { borderColor: "gray.200", bg: "#FCFCFD" },
  _focus: { bg: "white", borderColor: "blue.400", boxShadow: "outline" },
};

const theme = extendTheme({
  components: {
    Input: {
      variants: { filled: { field: inputStyles } },
      defaultProps: { variant: "filled" },
    },
    Select: {
      variants: { filled: { field: inputStyles } },
      defaultProps: { variant: "filled" },
    },
    Textarea: {
      variants: { filled: inputStyles },
      defaultProps: { variant: "filled" },
    },
    FormLabel: {
      baseStyle: {
        fontWeight: "bold", // ✅ Makes all form labels bold globally
        fontSize: "xs",
      },
    },
    Button: {
      baseStyle: {
        fontSize: "xs", // ✅ Ensures all buttons have 'xs' font size
        borderRadius: "3px", // ✅ Default border radius (adjust as needed)
      },
      variants: {
        solid: {
          fontSize: "xs",
        },
        outline: {
          fontSize: "xs",
        },
        ghost: {
          fontSize: "xs",
        },
        link: {
          fontSize: "xs",
        },
      },
      defaultProps: {
        size: "sm", // ✅ Applies 'xs' size by default
      },
    },
    Table: {
      baseStyle: {
        th: {
          py: 2, // Top/bottom padding for <Th>
          fontSize: "md",
          fontWeight: "bold",
          
        },
        td: {
          py: 2, // Top/bottom padding for <Td>
          fontSize: "md",
        },
      },
      defaultProps: {
        variant: "simple",
        size: "sm",
      },
    },
  },
});

export default theme;
